function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("polygon", {
  id: "profile-a",
  points: "0 0 16.364 0 16.364 7.273 0 7.273"
}),
/*#__PURE__*/
React.createElement("polygon", {
  id: "profile-c",
  points: "0 .057 7.627 .057 7.627 7.273 0 7.273"
}),
/*#__PURE__*/
React.createElement("polygon", {
  id: "profile-e",
  points: "0 0 5.454 0 5.454 8.182 0 8.182"
}));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 2.818)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(3.636 9.09)"
},
/*#__PURE__*/
React.createElement("mask", {
  id: "profile-b",
  fill: "#fff"
},
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#profile-a"
})),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M0.917090909,7.27272727 C0.858,7.27272727 0.796181818,7.26727273 0.736181818,7.25454545 C0.239818182,7.15636364 -0.082,6.67636364 0.018,6.18454545 C0.605272727,3.28909091 2.92618182,0.958181818 6.07709091,0.101818182 C6.46163636,-0.00181818182 6.86527273,0.0763636364 7.18527273,0.317272727 C7.50436364,0.559090909 7.69436364,0.939090909 7.69436364,1.33636364 L7.69436364,1.86363636 L8.85618182,0.466363636 C9.16890909,0.0927272727 9.67709091,-0.0781818182 10.1470909,0.0345454545 C13.1461818,0.744545455 15.508,2.85363636 16.3089091,5.53818182 C16.4289091,5.94727273 16.3498182,6.37818182 16.0907273,6.72181818 C15.8307273,7.06636364 15.4161818,7.27272727 14.9834545,7.27272727 L11.908,7.27272727 C11.4007273,7.27272727 10.9916364,6.86545455 10.9916364,6.36363636 C10.9916364,5.86181818 11.4007273,5.45454545 11.908,5.45454545 L14.3334545,5.45454545 C13.6052727,3.77181818 12.028,2.45090909 10.0498182,1.88818182 L8.13163636,4.19363636 C7.78254545,4.61272727 7.22345455,4.76454545 6.70890909,4.58090909 C6.19527273,4.39636364 5.86163636,3.92727273 5.86163636,3.38454545 L5.86163636,2.08181818 C3.74345455,2.88 2.22072727,4.53909091 1.81436364,6.54272727 C1.72709091,6.97454545 1.34436364,7.27272727 0.917090909,7.27272727",
  mask: "url(#profile-b)"
})),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M11.8181818,0 C9.81818182,0 8.18181818,1.63636364 8.18181818,3.63636364 L8.18181818,4.54545455 C8.18181818,6.54545455 9.81818182,8.18181818 11.8181818,8.18181818 C13.8181818,8.18181818 15.4545455,6.54545455 15.4545455,4.54545455 L15.4545455,3.63636364 C15.4545455,1.63636364 13.8181818,0 11.8181818,0 M11.8181818,1.81818182 C12.8209091,1.81818182 13.6363636,2.63363636 13.6363636,3.63636364 L13.6363636,4.54545455 C13.6363636,5.54818182 12.8209091,6.36363636 11.8181818,6.36363636 C10.8154545,6.36363636 10,5.54818182 10,4.54545455 L10,3.63636364 C10,2.63363636 10.8154545,1.81818182 11.8181818,1.81818182"
}),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 9.09)"
},
/*#__PURE__*/
React.createElement("mask", {
  id: "profile-d",
  fill: "#fff"
},
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#profile-c"
})),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M5.86209091,2.25627273 C6.38209091,1.75718182 6.97209091,1.31809091 7.62663636,0.953545455 C7.54754545,0.704454545 7.39845455,0.479 7.18481818,0.317181818 C6.86572727,0.0762727273 6.46118182,-0.00190909091 6.07663636,0.101727273 C2.92663636,0.958090909 0.605727273,3.289 0.0175454545,6.18445455 C-0.0815454545,6.67627273 0.239363636,7.15627273 0.734818182,7.25536364 C0.796636364,7.26718182 0.857545455,7.27263636 0.917545455,7.27263636 C1.34390909,7.27263636 1.72663636,6.97445455 1.81481818,6.54263636 C2.22027273,4.539 3.74390909,2.87990909 5.86209091,2.08172727 L5.86209091,2.25627273 Z",
  mask: "url(#profile-d)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(4.545)"
},
/*#__PURE__*/
React.createElement("mask", {
  id: "profile-f",
  fill: "#fff"
},
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#profile-e"
})),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M4.10690909,6.29436364 C3.956,6.33436364 3.79963636,6.36345455 3.636,6.36345455 C2.63418182,6.36345455 1.81781818,5.548 1.81781818,4.54527273 L1.81781818,3.63618182 C1.81781818,2.63436364 2.63418182,1.818 3.636,1.818 C3.79963636,1.818 3.956,1.84709091 4.10690909,1.88709091 C4.426,1.31436364 4.88872727,0.838909091 5.45418182,0.508 C4.91690909,0.193454545 4.30054545,-0.000181818182 3.636,-0.000181818182 C1.636,-0.000181818182 -0.000363636364,1.63618182 -0.000363636364,3.63618182 L-0.000363636364,4.54527273 C-0.000363636364,6.54527273 1.636,8.18163636 3.636,8.18163636 C4.30054545,8.18163636 4.91690909,7.988 5.45418182,7.67345455 C4.88872727,7.34254545 4.426,6.86709091 4.10690909,6.29436364",
  mask: "url(#profile-f)"
})));

var SvgProfile = function SvgProfile(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props), _ref, _ref2)
  );
};

export default SvgProfile;